import { useRouter } from 'next/router'
import React, { FC, useEffect } from 'react'

import { NextSeo } from 'next-seo'
import { useDispatch, useSelector } from 'react-redux'

import { Box, Container, NoSsr } from '@material-ui/core'

import AppLayout from '~/components/layouts/AppLayout'
import { bgImage } from '~/components/layouts/StaticContentLayout'
import HeroSection from '~/components/shared/HeroSection'
import Text, { Title } from '~/components/shared/Text'

import { fetchPackages } from '~/state/modules/package'
import { isLogged } from '~/state/modules/user'
import Paths from '~/utils/paths'

import { getEntityByBrand } from '~/brands'

import Packages from '../Packages/Packages'

import SellingEasySection from './components/SellingEasySection/SellingEasySection'
import SellWithUsSection from './components/SellWithUsSection/SellWithUsSection'

const titleName = getEntityByBrand({
  rv: 'Sell your RV',
  boat: 'Sell your Boat'
})

const seoText = getEntityByBrand<string>({
  rv: 'Trade Rv -Sell your caravans, camper or motorhome',
  boat: 'Trade a Boat Private Seller Packages'
})

const SellYourVessel: FC = () => {
  const dispatch = useDispatch()
  const logged = useSelector(isLogged)
  const router = useRouter()

  useEffect(() => {
    dispatch(fetchPackages('private'))
  }, [])

  const redirectLink = logged ? Paths.sell.index : Paths.auth.signUp

  const handleClick = () => router.push(redirectLink)

  return (
    <>
      <NextSeo
        title={seoText}
        description={seoText}
        openGraph={{
          title: seoText,
          description: seoText
        }}
      />
      <NoSsr>
        <AppLayout bgcolor="bg.primary.main">
          <HeroSection darkness height="350px" src={bgImage}>
            <Title
              m="auto"
              variant="h1"
              textAlign="center"
              style={{ color: 'white' }}
            >
              {titleName}
            </Title>
          </HeroSection>

          <SellWithUsSection redirectLink={redirectLink} />

          <Box width="100vw" pt={4} pb={6} bgcolor="#F9FAFB">
            <Container maxWidth="lg">
              <Text
                textAlign="center"
                fontFamily="Prompt, sans-serif"
                fontSize={{ xs: 24, md: 35 }}
                mb={{ xs: 1, md: 2 }}
                fontWeight={600}
              >
                Packages
              </Text>

              <Text
                fontSize={{ xs: 16, md: 18 }}
                textAlign="center"
                mb={{ xs: 2.5, md: 4.5 }}
              >
                Select the package below which best suits your needs.
              </Text>

              <Packages onClick={handleClick} buttonText="Create Listing" />
            </Container>
          </Box>

          <SellingEasySection />
        </AppLayout>
      </NoSsr>
    </>
  )
}

export default SellYourVessel
